module.exports = __webpack_public_path__ + "img/image02_sp.db34b3aa.jpg";